import { BoxProps, Text as ChakraText } from '@chakra-ui/react'
import { withShade } from './utils'

export const Text = withShade<BoxProps>(ChakraText)
